import React, {ReactNode, startTransition, useEffect, useState} from "react";
import {RadioProvider} from "../../../../../contexts/useRadio";
import {useSuspenseQuery} from "@tanstack/react-query";
import {useRadioDetailKey} from "../../../../../queriesKeys/useRadioKey";
import {useParams} from "react-router-dom";

export default function Layout(props: {
    children: ReactNode
}) {

    const { slug } = useParams();
    const { data: radio } = useSuspenseQuery(useRadioDetailKey(slug!));

    const [originalPath, setOriginalPath] = useState<string|null>(radio.background ?? null);

    const [background, setBackground] = useState<null | {
        url: string,
        width: number,
        height: number
    }>(null);


    useEffect(() => {
        if (!originalPath)
            return;
        const controller = new AbortController();
        (async () => {
            try {
                const bg = await fetch(originalPath, {signal: controller.signal}).then(x => x.blob())
                if (controller.signal.aborted)
                    return;

                const url = URL.createObjectURL(bg);
                const image = new Image();
                image.onload = () => {
                    if (controller.signal.aborted)
                        return;
                    const width = image.width;
                    const height = image.height;
                    startTransition(() => {
                        setBackground({
                            width,
                            height,
                            url
                        })
                    });
                }
                image.src = url;
            }
            catch (e) {

            }

        })();
        return () => controller.abort();
    }, [originalPath]);

    useEffect(() => {
        if (background) {
            document.body.classList.add("image_leaderboard");
        } else {
            document.body.classList.remove("image_leaderboard");
        }
    }, [background]);

    useEffect(() => {

        if (radio.backgroundUrl) {
            let clicked = false;
            const onclick = (ev:MouseEvent) => {
                if (clicked)
                    return;
                const element = ev.srcElement ?? ev.target;
                if (element === document.getElementById("root")
                    || element === document.getElementsByTagName("html").item(0)) {
                    setTimeout(() => {
                        clicked = false;
                    }, 500);
                    clicked = true;
                    window.open(radio.backgroundUrl, "_blank");
                }
            }

            document.addEventListener("click", onclick);
            return () => {
                document.removeEventListener("click", onclick);
            }
        }
    }, [radio.backgroundUrl]);

    useEffect(() => {
        return () => document.body.classList.remove("image_leaderboard");
    }, []);

    useEffect(() => {

        if ((radio.background ?? null) === originalPath)
            return;
        startTransition(() => {
            if (radio?.background) {
                setOriginalPath(radio?.background);
            }
            else {
                setOriginalPath(null);
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [radio.background ?? null]);



    return <>{background && originalPath ?
        <style>{`
          body {
                  background-image: url(${background.url});
                  background-size: 100% auto;
                  background-attachment: fixed;
                  background-repeat: no-repeat !important;

                }
                @media screen and (max-width: ${background.width}px) {
                  body {
                    background-size: ${background.width}px ${background.height}px;
                  }
                }
            `}</style>: null}
        <RadioProvider radio={radio}>
        {props.children}
        </RadioProvider>
    </>;
}